import { useRecoilState } from "recoil";
import { subTemas } from "../atom";

const useSubTemasState = () => {
    return useRecoilState(subTemas);
};

export default useSubTemasState;